<template>
  <v-dialog
    v-model="show"
    persistent
    @keydown.esc="hide"
    width="500"
    v-if="role('admin', 'safetyRepresentative')"
    ><template v-slot:activator="{ on }">
      <v-btn
        v-if="role('admin', 'safetyRepresentative')"
        v-on="on"
        :loading="$apollo.loading"
        class="primary accent-4 white--text mr-2"
      >
        <v-icon dark left>add</v-icon>
        {{ $t("extTrainings.group.change") }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t("extTrainings.group.change") }}
      </v-card-title>
      <v-card-text>
        {{ $t("extTrainings.group.existingGroups") }}

        <v-row no-gutters class="my-2">
          <template v-for="group in extTrainingGroups">
            <v-chip
              :key="`${group.name}`"
              @click="name = group.name"
              close
              class="mr-1 mb-1"
              close-icon="delete_forever"
              @click:close="alert = group.name"
              ><a style="text-decoration: underline;">{{
                group.name
              }}</a></v-chip
            >
          </template>
        </v-row>
        <v-form ref="form">
          <v-text-field
            v-model="name"
            :rules="[rules.required]"
            class=""
            :label="
              isNewGroupName
                ? $t('extTrainings.group.newName')
                : $t('extTrainings.group.name')
            "
            hide-details="auto"
          />
          <v-autocomplete
            class=""
            v-model="newCategories"
            :items="categories"
            chips
            :label="$t('extTrainings.group.categoriesRelatedToGroup')"
            deletable-chips
            item-text="category"
            return-object
            multiple
          >
          </v-autocomplete>
        </v-form>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey" text @click="hide">{{ $t("dialog.cancel") }}</v-btn>

        <v-btn color="primary" text @click="change" :loading="loading">{{
          isNewGroupName ? $t("dialog.add") : $t("dialog.change")
        }}</v-btn>
      </v-card-actions>
    </v-card>
    <alert
      :alert="alert"
      :title="$t('dialog.delete')"
      :text="
        `
        ${$t('dialog.delete')} ${alert}
        `
      "
      :okText="$t('dialog.delete')"
      @cancel="alert = null"
      @ok="deleteGroup($event)"
    />
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

import UpsertExtTrainingGroup from "@/graphql/mutation/extTraining/UpsertExtTrainingGroup.gql";
import DeleteExtTrainingGroup from "@/graphql/mutation/extTraining/DeleteExtTrainingGroup.gql";

import Alert from "@/components/Alert";

export default {
  props: ["categories", "extTrainingGroups"],
  components: {
    Alert,
  },
  data() {
    return {
      name: "",
      newCategories: [],
      loading: false,
      show: false,
      alert: null,
      rules: {},
    };
  },
  mounted() {
    this.deactivateRules();
  },
  watch: {
    name() {
      if (this.extTrainingGroups && this.extTrainingGroups.length) {
        const group = this.extTrainingGroups.find((x) => x.name == this.name);
        if (!group) {
          this.newCategories = [];

          return;
        }
        this.newCategories = group.extTrainingCategories;
      }
    },
  },
  computed: {
    ...mapGetters(["role"]),
    isNewGroupName() {
      if (this.extTrainingGroups && this.extTrainingGroups.length) {
        const group = this.extTrainingGroups.find((x) => x.name == this.name);
        return !group;
      }
      return false;
    },
  },
  methods: {
    hide() {
      this.deactivateRules();
      this.$refs.form.resetValidation();
      this.name = "";
      this.newCategories = [];
      this.show = false;
    },
    change() {
      this.activateRules();
      this.$nextTick(() => {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.$apollo
            .mutate({
              mutation: UpsertExtTrainingGroup,
              variables: {
                name: this.name,
                categoryIds: this.newCategories.map((x) => x.id),
              },
            })
            .then(() => {
              this.$emit("refreshGroups");
              this.hide();
            })
            .catch((err) => {
              this.$store.commit("push_global_message", {
                color: "error",
                text: err,
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    deleteGroup(name) {
      if (!name) {
        return;
      }
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: DeleteExtTrainingGroup,
          variables: {
            name,
          },
        })
        .then(() => {
          this.$emit("refreshCategories");
          this.$store.commit("push_global_message", {
            color: "warning",
            text: `${this.$t("extTrainings.group.deleted")} ${name}`,
          });
          this.$emit("refreshGroups");
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            color: "error",
            text: err,
          });
        })
        .finally(() => {
          this.alert = null;
          this.loading = false;
        });
    },
    deactivateRules() {
      this.rules = {
        required: () => true,
      };
    },
    activateRules() {
      this.rules = {
        required: () => !!this.name || this.$i18n.t("validation.required"),
      };
    },
  },
};
</script>
